import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n' // i18next initialization — must be before App render
import { installKeyboardFocusTracker } from './utils/keyboardFocus'
import { APP_VERSION } from './constants/appVersion'
import { isDebugMode } from './utils/debugMode'

// Bumped on every change so user can verify preview is fresh.
// Logged when ?debug=true is in URL. Lives in src/constants/appVersion.ts so
// debug clipboard exports can stamp the same marker.

if (isDebugMode()) {
  // eslint-disable-next-line no-console
  console.info(`[App] version: ${APP_VERSION}`);
}

// Focus rings appear only after Tab navigation; mouse/touch and other
// keys (Esc, Enter, arrows…) suppress :focus-visible globally.
installKeyboardFocusTracker();


// Global error handlers for early error detection
window.onerror = (message, source, lineno, colno, error) => {
  console.error('[Global Error]', { message, source, lineno, colno, error });
  return false; // Let default handler run
};

window.onunhandledrejection = (event) => {
  console.error('[Unhandled Promise Rejection]', event.reason);
};

// Safe app mounting with error recovery
try {
  createRoot(document.getElementById("root")!).render(<App />);
} catch (error) {
  console.error('[App Start] Failed to mount:', error);
  // Show user-friendly error
  const root = document.getElementById("root");
  if (root) {
    root.innerHTML = `
      <div style="padding: 40px; font-family: system-ui, -apple-system, sans-serif; max-width: 600px; margin: 0 auto;">
        <h1 style="color: #2B2253; margin-bottom: 16px;">Aplikáciu sa nepodarilo spustiť</h1>
        <p style="color: #6B7280; margin-bottom: 24px;">
          Skúste prosím obnoviť stránku alebo použite iný prehliadač.
        </p>
        <details style="background: #f5f5f5; padding: 16px; border-radius: 8px; font-family: monospace; font-size: 12px;">
          <summary style="cursor: pointer; margin-bottom: 8px;">Technické detaily</summary>
          <pre style="margin: 0; overflow: auto; white-space: pre-wrap;">${error}</pre>
        </details>
      </div>
    `;
  }
}
